import instance from "@/services/api";

export const framesListAPI = {
  async getList(resident_id) {
    return await instance()
      .get(`project_list/frame/${resident_id}/read/`)
      .then((res) => res?.data);
  },
  async getFrameTypes(body) {
    return await instance()
      .post("/project_list/common/flat/floor/", body)
      .then((res) => res?.data);
  },
  async getFrameParams(frame_id) {
    return await instance()
      .get(`/project_list/frame/${frame_id}/frame_param_read/`)
      .then((res) => res?.data);
  },
  async getParamsByFrame(frame_type_id) {
    return await instance()
      .get(`/project_list/frame/${frame_type_id}/param_type_by_frame_type/`)
      .then((res) => res?.data);
  },
  async updateFrame(body) {
    return await instance()
      .post("/project_list/frame/frame_upd/", body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },
  async deleteFrame(frame_id) {
    return await instance()
      .delete(`/project_list/frame/${frame_id}/frame_delete/`)
      .then((res) => res?.data);
  },
  async updateFrameParams(body) {
    return await instance()
      .post("/project_list/frame/frame_param_upd/", body)
      .then((res) => res?.data);
  },
  async deleteFrameParam(frame_param_id) {
    return await instance()
      .post(`/project_list/frame/frame_param_del/`, { frame_param_id })
      .then((res) => res?.data);
  },
  async calculateSquare(body) {
    return await instance()
      .post("/project_list/frame/frame_param_calculate_area/", body)
      .then((res) => res?.data);
  },
};
